if (document.querySelector('iframe') != null) {
    let _ = import(
        /* webpackChunkName: "nettno-reframe" */
        /* webpackMode: "lazy" */

        "./reframe.js"
    );
}
